<template>
  <v-container grid-list-xl class="pa-5">
    <v-row wrap>
      <v-col cols="12">
        <v-alert v-if="is_premium" dense text class="body-2 mb-5" type="info">
          Berikut ini merupakan data klaim presensi dari pengguna yang dicatatkan operator instansi. Klik tombol (+)
          jika ingin mengubah data presensi. Fitur <b>Ubah Presensi</b> ini untuk memfasilitasi operator mengubah kategori skor
          keterlambatan berdasarkan klaim yang disampaikan oleh pengguna kepada operator. Misalkan dari awalnya <i>tidak
          presensi</i> karena berkendala, menjadi <i>presensi</i> sehingga tidak terkena skor keterlambatan
        </v-alert>

        <m-card-list
          two-line
          title="Ubah Presensi"
          label-cari="Cari Presensi"
          :add="isCan('presensi-klaim.store')"
          edit
          select
          filterUser
          filterWaktu
          @filter="filter"
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @search="
            (search) => {
              textSearch = search
              load()
            }
          "
          @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
          @add="add"
        >
          <template v-slot:items="{ item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>{{ pVal(item, 'wkt_presensi') | toD }}</td>
              <td>
                <p class="subtitle font-weight-bold my-0 py-0">
                  {{ pVal(item.users, 'nama') }}
                </p>
                <p class="caption grey--text my-0 py-0">
                  {{ pVal(item.users, 'email') }}
                </p>
              </td>
              <td>{{ pVal(item, 'skor_datang') }}</td>
              <td>{{ pVal(item, 'skor_istirahat_mulai') }}</td>
              <td>{{ pVal(item, 'skor_istirahat_selesai') }}</td>
              <td>{{ pVal(item, 'skor_pulang') }}</td>
              <td>{{ pVal(item, 'created_at') | toD }}</td>
              <td>
                <m-menu left style="float:right" :items="more_menu" :object="item" />
              </td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Tanggal Presensi
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, 'wkt_presensi') | toD }}
                </div>
              </td>

              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Nama
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item.users, 'nama') }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Skor Datang
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, 'skor_datang') }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Skor Awal Istirahat
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, 'skor_istirahat_mulai') }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Skor Akhir Istirahat
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, 'skor_istirahat_selesai') }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Skor Pulang
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, 'skor_pulang') }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Tanggal Input
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, 'created_at') | toD }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Aksi
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <m-menu left style="float:right" :items="more_menu" :object="item" />
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
    </v-row>
    <ChangeDlg ref="dlg" />
    <DetailDlg ref="detailDlg" />
  </v-container>
</template>

<script>
import { isCan } from '@/tools'
import ChangeDlg from '../components/Form.vue'
import DetailDlg from '../pages/Detail.vue'
import BlockCard from '@/components/BlockCard'

export default {
  components: {
    ChangeDlg,
    DetailDlg,
    BlockCard,
  },
  data() {
    return {
      klaimPresensi: {
        tanggalAwal: null,
        tanggalAkhir: null,
        user_id: 0,
      },
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: 'Tanggal Presensi', align: 'left', value: 'tanggal' },
        { text: 'Nama', align: 'left', value: 'user' },
        { text: 'Skor Datang', align: 'left', value: 'skor_datang' },
        { text: 'Skor Awal Istirahat', align: 'left', value: 'skor_istirahat_mulai' },
        { text: 'Skor Akhir Istirahat', align: 'left', value: 'skor_istirahat_selesai' },
        { text: 'Skor Pulang', align: 'left', value: 'skor_pulang' },
        { text: 'Tanggal Input', align: 'left', value: 'created_at' },
        { text: '', align: 'left', sortable: false },
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] },
      },
      more_menu: [
        {
          title: 'Pratinjau',
          click: (i, o) => this.detil(o),
        },
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
          check: () => isCan('presensi-klaim.store'),
        },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: () => isCan('presensi-klaim.store'),
        },
      ],
    }
  },
  computed: {},
  activated() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('klaimPresensi/get', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            tgl_awal: this.klaimPresensi.tanggalAwal,
            tgl_akhir: this.klaimPresensi.tanggalAkhir,
            user_id: this.klaimPresensi.user_id || 0,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    detil(item) {
      this.$refs.detailDlg.open(item)
    },
    add() {
      this.$refs.dlg.open({ obj: {} }).then(() => {
        this.load()
      })
    },
    filter(data) {
      this.cp = 1
      if (data.dateRange) {
        this.klaimPresensi.tanggalAwal = data.from
        this.klaimPresensi.tanggalAkhir = data.to
      } else {
        this.klaimPresensi.tanggalAwal = null
        this.klaimPresensi.tanggalAkhir = null
      }
      this.klaimPresensi.user_id = data.user
      this.load()
    },
    async edit(item) {
      const resp = await this.$store
        .dispatch('jamKerja/jadwalUser', {
          organisasi_id: this.organisasi_id || this.tenant_id,
          user_id: item.user_id,
          params: {
            tgl: item.wkt_presensi.split(' ')[0] || '',
          },
        })
        .then(({ data }) => data)

      let parsing = item
      this.$set(parsing, 'wkt_presensi', item.wkt_presensi.split(' ')[0] || '')
      this.$set(parsing, 'jadwal_detail_id', (resp && resp.resp) || '')

      this.$refs.dlg
        .open(Object.assign({}, { obj: parsing, jadwal: (resp && resp.konfigurasi_jadwal) || {} }))
        .then(() => {
          this.load()
        })
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.keterangan}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch('klaimPresensi/drop', {
            organisasi_id: this.organisasi_id,
            presensi_klaim_id: item.presensi_klaim_id,
          })
        )
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
  },
}
</script>
